import { HealthConnectionsContainer } from '@screens/HealthConnections/HealthConnectionsContainer';
import {
  useGetMyHealthConnectionListV2,
  useGetMyDiseaseRiskListV2,
} from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { useIsProUser } from '@/hooks/useIsProUser';

const HealthConnectionsList = () => {
  const { data: healthConnectionListData, isLoading } = useGetMyHealthConnectionListV2();
  const { connections = [], description = '', title = '' } = healthConnectionListData || {};
  return (
    <HealthConnectionsContainer
      connections={connections}
      title={title}
      description={description}
      isLoading={isLoading}
    />
  );
};

const DiseaseRiskList = () => {
  const { data: diseaseRiskListData, isLoading } = useGetMyDiseaseRiskListV2();
  const { connections = [], description = '', title = '' } = diseaseRiskListData || {};
  return (
    <HealthConnectionsContainer
      connections={connections}
      title={title}
      description={description}
      isLoading={isLoading}
      isProUser
    />
  );
};

export const HealthConnectionsPage = () => {
  const isProUser = useIsProUser();

  return (
    <div className="dark bg-black h-full w-full">
      {isProUser ? <DiseaseRiskList /> : <HealthConnectionsList />}
    </div>
  );
};
